export const statuses = [
  "no contact",
  "no answer",
  "not interested",
  "pending",
  "posted",
  "paid offer",
  "trial",
];
